export default {
  title: 'Checkout',
  subtitle: 'Review and place your order',
  progress: {
    cart: 'Cart',
    checkout: 'Checkout',
    confirmation: 'Confirmation',
  },
  secure: 'Secure',
  emailNotVerified: {
    heading: 'Please verify your email to place orders',
    body: 'Check your inbox for the verification link, or resend it from your {dashboardLink}.',
    dashboardLinkText: 'dashboard',
  },
  orderSummary: 'Order Summary',
  soldBy: 'Sold by {merchant}',
  keyLabel: '{platform} Key',
  billingInfo: 'Billing Info',
  billingMissing: {
    heading: 'Billing address missing',
    body: 'Add your address in Settings before you can place an order.',
  },
  dob: 'DOB: {date}',
  payment: 'Payment — Wallet',
  walletAvailable: '{amount} available',
  insufficientFunds: 'Not enough funds — top up to complete this order.',
  sufficientFunds: 'Sufficient funds for this transaction.',
  topUp: 'Top up',
  partialError: {
    heading: "Some items couldn't be ordered:",
    footer: 'Successful items have been moved to your orders. The rest remain in your cart.',
  },
  totalToPay: 'Total to pay',
  subtotal: 'Subtotal',
  total: 'Total',
  walletDeduction: 'Will be deducted from your wallet',
  placeOrder: 'Place order',
  placingOrder: 'Placing order…',
  terms: 'By placing this order, you agree to our {termsLink} and {privacyLink}. Digital keys are non-refundable once revealed.',
  termsLinkText: 'Terms of Service',
  privacyLinkText: 'Privacy Policy',
  instantDelivery: 'Keys delivered instantly',
  footerNotice: '© GladKey 2026 · Secure checkout',
  empty: {
    heading: 'Your cart is empty.',
    body: 'Add a few keys before checking out.',
    cta: 'Browse catalog',
  },
};
